/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { url } from 'utils/urls';
// global elements
import Structure from 'components/shared/structure/structure_container';
import Loader from 'components/shared/loader/loader';
// unique elements
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import InsticatorLogo from 'components/shared/logo/insticator/insticator_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/screens/fetchingquestions/fetchingquestions_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ FETCHING QUESTIONS SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const FetchingQuestionsScreen = (props) => {
    const createMarkup = () => (
        <div className={`fetchingquestions uniquescreen`}>
            <Title>{`Fetching Questions`}</Title>
            <Loader type={'ellipsis'} />
            <BodyCopy>
                <p>Hang on! We'll have more questions for you momentarily.</p>
            </BodyCopy>
        </div>
    );

    return(
        <div className={`${sheet.classes.uniquecontent} uniquecontent inview-${props.inView}`}>
            <Structure contentId={props.contentId} markup={createMarkup()} />
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default FetchingQuestionsScreen;
